import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { ObservableInput } from 'observable-input';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap, withLatestFrom } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { SuperTableSelectable } from './super-table-selectable';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'super-table-checkbox',
  templateUrl: './super-table-checkbox.component.html',
})
export class SuperTableCheckbox<T> implements OnDestroy {
  readonly destroy = new Subject();

  readonly doSelect = new Subject<boolean>();

  @Input()
  @ObservableInput()
  value!: Subject<T | null>;

  @Input()
  checkboxDisabled: boolean = false;

  readonly selected = this.value.pipe(
    switchMap(id => this.superTableSelectable.selected(id!)),
  );

  private readonly select = this.doSelect.pipe(
    withLatestFrom(this.value),
    tap(([value, id]) => {
      if (!this.checkboxDisabled) {
        this.superTableSelectable.select(id, value);
      }
    }),
  );

  constructor(private readonly superTableSelectable: SuperTableSelectable<T>) {
    this.value.next(null);
    this.select.pipe(takeUntil(this.destroy)).subscribe();
  }

  ngOnDestroy() {
    this.destroy.next(undefined);
  }

  UUID = uuidv4();
}
